'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'image';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = ['M48 80l0 352 352 0 0-352-352 0zM80 384l80-128 32.4 51.9 63.6-99.9 112 176-288 0zm80-224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M400 80l0 352-352 0 0-352 352 0zM48 32l-48 0 0 448 448 0 0-448-400 0zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 48l-63.6 99.9-32.4-51.9-80 128 288 0-112-176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;